<app-breadcrumb [title]="'Documentos'" [items]="['Vehiculos']" [active_item]="'Documentos'"></app-breadcrumb>
<div class="container-fluid">
<div class="col-xl-12 d-flex flex-wrap row justify-content-around">


  <!-- <div class="col-xl-3">
    <div class="card shadow-lg animated-card" style="transition: box-shadow 0.3s;">
      <button class="btn btn-primary py-4" data-bs-toggle="collapse" data-target="#collapseicon4" aria-expanded="true"
        aria-controls="collapseicon4" (click)="isFechas = !isFechas" [attr.aria-expanded]="!isFechas">
        <i class="icofont icofont-ui-calendar me-2"></i>
        <strong>DOCUMENTOS SIN FECHAS</strong>
      </button>
      <div class="collapse show" id="collapseicon2" aria-labelledby="collapseicon2" data-parent="#accordion">
        <div class="card-body filter-cards-view animate-chk p-2" [ngbCollapse]="isFechas">
          <div class="categories">
            <ul>
              <ng-container *ngIf="!loadingSinFecha; else skeletonLoaderSinFecha">
                <li *ngFor="let documento of documentosSinFecha" (click)="abrirModal(documento.nombre,'sinFecha')"
                  class="documento-item" style="cursor: pointer; transition: background 0.2s;"
                  (mouseenter)="$event.target.classList.add('bg-light')"
                  (mouseleave)="$event.target.classList.remove('bg-light')">
                  <a href="javascript:void(0)" style="font-size: 0.8rem; font-weight: 500;">
                    {{ documento.nombre }}
                  </a>
                  <span class="badge badge-primary pull-right">{{ documento.total }}</span>
                </li>
              </ng-container>
              <ng-template #skeletonLoaderSinFecha>
                <li *ngFor="let sk of [1,2,3,4]" class="skeleton-loader mb-2" style="height: 32px; border-radius: 6px; background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%); animation: skeleton-loading 1.2s infinite;">
                  &nbsp;
                </li>
              </ng-template>
            </ul>
            <button
              class="btn btn-outline-primary w-100 rounded d-flex justify-content-center align-items-center gap-2 mt-3 px-4 btn-efecto"
              (mouseenter)="$event.target.classList.add('shadow')"
              (mouseleave)="$event.target.classList.remove('shadow')"
              (click)="exportarDocumentosSinFecha('SIN FECHA')">
              <i class="icofont icofont-download-alt"></i>
              <strong>Ver Detalles</strong>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <div class="col-xl-4">
    <div class="card shadow-lg animated-card" style="transition: box-shadow 0.3s;">
      <button class="btn btn-danger py-4" data-bs-toggle="collapse" data-target="#collapseicon4" aria-expanded="true"
        aria-controls="collapseicon4" (click)="isVencidos = !isVencidos" [attr.aria-expanded]="!isVencidos">
        <i class="icofont icofont-road f-w-600"></i>
        <strong>DOCUMENTOS VENCIDOS</strong>
      </button>
      <div class="collapse show" id="collapseicon2" aria-labelledby="collapseicon2" data-parent="#accordion">
        <div class="card-body filter-cards-view animate-chk p-2" [ngbCollapse]="isVencidos">
          <div class="categories">
            <ul>
              <ng-container *ngIf="!loadingVencidos; else skeletonLoaderVencidos">
                <li *ngFor="let documento of documentosVencidos" (click)="abrirModal(documento.nombre,'vencidos')"
                  class="documento-item" style="cursor: pointer; transition: background 0.2s;"
                  (mouseenter)="$event.target.classList.add('bg-light')"
                  (mouseleave)="$event.target.classList.remove('bg-light')">
                  <a href="javascript:void(0)" style="font-size: 0.8rem; font-weight: 500;">
                    {{ documento.nombre }}
                  </a>
                  <span class="badge badge-danger pull-right">{{ documento.total }}</span>
                </li>
              </ng-container>
              <ng-template #skeletonLoaderVencidos>
                <li *ngFor="let sk of [1,2,3,4]" class="skeleton-loader mb-2" style="height: 32px; border-radius: 6px; background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%); animation: skeleton-loading 1.2s infinite;">
                  &nbsp;
                </li>
              </ng-template>
            </ul>
            <button
              class="btn btn-outline-danger w-100 rounded d-flex justify-content-center align-items-center gap-2 mt-3 px-4 btn-efecto"
              (mouseenter)="$event.target.classList.add('shadow')"
              (mouseleave)="$event.target.classList.remove('shadow')"
              (click)="exportarDocumentosSinFecha('VENCIDOS')">
              <i class="icofont icofont-download-alt"></i>
              <strong>Ver Detalles</strong>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-xl-4">
    <div class="card shadow-lg animated-card" style="transition: box-shadow 0.3s;">
      <button class="btn btn-warning py-4" data-bs-toggle="collapse" data-target="#collapseicon4" aria-expanded="true"
        aria-controls="collapseicon4" (click)="isVencer = !isVencer" [attr.aria-expanded]="!isVencer">
        <i class="icofont icofont-ssl-security"></i>
        <strong>DOCUMENTOS POR VENCER</strong>
      </button>
      <div class="collapse show" id="collapseiconPorVencer" aria-labelledby="collapseiconPorVencer"
        data-parent="#accordion">
        <div class="card-body filter-cards-view animate-chk p-2" [ngbCollapse]="isVencer">
          <div class="categories">
            <ul>
              <ng-container *ngIf="!loadingPorVencer; else skeletonLoaderPorVencer">
                <li *ngFor="let documento of documentosPorVencer" (click)="abrirModal(documento.nombre,'porVencer')"
                  class="documento-item" style="cursor: pointer; transition: background 0.2s;"
                  (mouseenter)="$event.target.classList.add('bg-light')"
                  (mouseleave)="$event.target.classList.remove('bg-light')">
                  <a href="javascript:void(0)" style="font-size: 0.8rem; font-weight: 500;">
                    {{ documento.nombre }}
                  </a>
                  <span class="badge badge-warning pull-right">{{ documento.total }}</span>
                </li>
              </ng-container>
              <ng-template #skeletonLoaderPorVencer>
                <li *ngFor="let sk of [1,2,3,4]" class="skeleton-loader mb-2" style="height: 32px; border-radius: 6px; background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%); animation: skeleton-loading 1.2s infinite;">
                  &nbsp;
                </li>
              </ng-template>
            </ul>
            <button
              class="btn btn-outline-warning w-100 rounded d-flex justify-content-center align-items-center gap-2 mt-3 px-4 btn-efecto"
              (mouseenter)="$event.target.classList.add('shadow')"
              (mouseleave)="$event.target.classList.remove('shadow')"
              (click)="exportarDocumentosSinFecha('POR VENCER')">
              <i class="icofont icofont-download-alt"></i>
              <strong>Ver Detalles</strong>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="col-xl-4">
    <div class="card shadow-lg animated-card" style="transition: box-shadow 0.3s;">
      <button class="btn btn-success py-4" data-bs-toggle="collapse" data-target="#collapseicon4" aria-expanded="true"
        aria-controls="collapseicon4" (click)="isVigentes = !isVigentes" [attr.aria-expanded]="!isVigentes">
        <i class="icofont icofont-check-circled "></i>
        <strong>DOCUMENTOS VIGENTES</strong>
      </button>

      <div class="collapse show" id="collapseicon4" aria-labelledby="collapseicon4" data-parent="#accordion">
        <div class="card-body filter-cards-view animate-chk p-2" [ngbCollapse]="isVigentes">
          <div class="categories">
            <ul>
              <ng-container *ngIf="!loadingVigentes; else skeletonLoaderVigentes">
                <li *ngFor="let documento of documentosVigentes" (click)="abrirModal(documento.nombre,'vigentes')"
                  class="documento-item" style="cursor: pointer; transition: background 0.2s;"
                  (mouseenter)="$event.target.classList.add('bg-light')"
                  (mouseleave)="$event.target.classList.remove('bg-light')">
                  <a href="javascript:void(0)" style="font-size: 0.8rem; font-weight: 500;">
                    {{ documento.nombre }}
                  </a>
                  <span class="badge badge-success pull-right">{{ documento.total }}</span>
                </li>
              </ng-container>
              <ng-template #skeletonLoaderVigentes>
                <li *ngFor="let sk of [1,2,3,4]" class="skeleton-loader mb-2" style="height: 32px; border-radius: 6px; background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%); animation: skeleton-loading 1.2s infinite;">
                  &nbsp;
                </li>
              </ng-template>
            </ul>

            <button
              class="btn btn-outline-success w-100 rounded d-flex justify-content-center align-items-center gap-2 mt-3 px-4 btn-efecto"
              (mouseenter)="$event.target.classList.add('shadow')"
              (mouseleave)="$event.target.classList.remove('shadow')"
              (click)="exportarDocumentosSinFecha('VIGENTE')">
              <i class="icofont icofont-download-alt"></i>
              <strong>Ver Detalles</strong>
            </button>

          </div>
        </div>
      </div>
    </div>
  </div>




</div>
<ng-template #myModal3 let-modal>
  <div class="modal-header">
    <h5 class="modal-title text-dark">{{ tituloModal }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">

<table class="table table-striped table-hover border rounded shadow-sm" id="tbldocumentosExport" style="font-family: 'Segoe UI', Arial, sans-serif;">
  <thead class="table-primary">
    <tr>
      <th class="text-center align-middle" style="font-size: 1rem; letter-spacing: 1px;"><strong>PLACA</strong></th>
      <th class="text-center align-middle" style="font-size: 1rem; letter-spacing: 1px;"><strong>FECHA DE VENCIMIENTO</strong></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let doc of selectedDocumentList | paginate: { itemsPerPage: pageSize1, currentPage: page1 }" class="align-middle" style="transition: background 0.2s;">
      <td class="text-center fw-semibold">{{ doc.placa }}</td>
      <td class="text-center">{{ doc.fecha ? (doc.fecha | date:'dd/MM/yyyy') : '' }}</td>
    </tr>
  </tbody>
</table>


    <div class="d-flex justify-content-between align-items-center mt-4">
      <!-- Selector de registros por página alineado a la izquierda -->
      <div class="d-flex align-items-center" *ngIf="selectedDocumentList.length >= 10">
        <label for="pageSize1" class="me-2 text-dark">Mostrar:</label>
        <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
          <option *ngFor="let size1 of [10, 20, 50, 100]" [value]="size1">{{ size1 }}</option>
        </select>
        <span class="ms-2 text-dark">registros por página</span>
      </div>


      <!-- Mostrar cantidad total de registros centrado -->
      <div class="mx-auto text-center">
        <span class="badge bg-primary ms-1"><b>Total Registros: {{ selectedDocumentList.length || 0 }}</b></span>
      </div>

      <!-- Paginador alineado a la derecha -->
      <div class="text-end paginador-personalizado">
        <pagination-controls (pageChange)="page1 = $event" [maxSize]="5" [directionLinks]="true" [autoHide]="true"
          previousLabel="Anterior" nextLabel="Siguiente">
        </pagination-controls>
      </div>
    </div>

<div class="d-flex align-items-center mt-3" style="position: relative;">
  <!-- Botón Salir al final -->
  <div class="ms-auto">
    <button type="button" class="btn btn-danger" (click)="modal.dismiss()">
      Cerrar
    </button>
  </div>

  <!-- Botón Excel con estilo personalizado para moverlo -->
  <div class="btn-showcase text-center" style="position: absolute; left: 51%; transform: translateX(-50%);">
   <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
  (click)="exportarExcel('tbldocumentosExport', 'Listado_Documentos')">
  <i class="icofont icofont-file-excel"></i> EXCEL
</button>

  </div>
</div>

  </div>
</ng-template>


<div class="text-center">
  <div class="row" style="margin-bottom: 10px;">
    <div class="">
      <button type="button" class="btn btn-primary" (click)="ExportarListadoVehiculos()">
        <strong>INFORME DE VENCIMIENTOS</strong>
      </button>


    </div>
  </div>
</div>